<template>
    <i :class="classes" :style="styles"></i>
</template>

<script>
export default {
    name: 'ElIcon',
    props: {
        type: {
            type: String,
            default: ''
        },
        size: [Number, String],
        hover: Boolean,
        color: String,
        prefixCls: {
            type: String,
            default: 'iconfont'
        }
    },
    computed: {
        classes() {
            return [
                `${this.prefixCls}`,
                {
                    [`${this.type}`]: this.type,
                    [`is-hover`]: this.hover,
                }
            ];
        },
        styles() {
            let style = {};

            if (this.size) {
                style['font-size'] = `${this.size}px`;
            }

            if (this.color) {
                style.color = this.color;
            }

            return style;
        }
    },
};
</script>
<style lang="scss" scoped>
  .is-hover{
    &:hover{
      color: #2198F0!important;
    }
  }
</style>
